import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import {WeaNewScroll} from 'ecCom';

@inject('portalThemeStore')
@observer
class E9QuickSearchTypes extends React.Component {
    constructor(props) {
        super(props);
        this.onQuickSearchTypesClick = this.onQuickSearchTypesClick.bind(this);
    }

    render() {
        const {portalThemeStore} = this.props;
        const {quickSearchTypes} = portalThemeStore;
        const _quickSearchTypes = toJS(quickSearchTypes);

        return (
            <div className="e9header-quick-search-types-content">
                {
                    _quickSearchTypes.map((item, index) => {
                        const {type, name, icon} = item;

                        let iconComp = null;
                        if (icon) {
                            if (type == 10) {
                                iconComp = <img src={icon} alt=""/>;
                            } else {
                                iconComp = <i className={icon} style={{fontSize: '16px', marginLeft: '1px', marginTop: '-8px'}}/>;
                            }
                        } else {
                            iconComp = <i className={`wevicon-quick-search-${type}`}/>;
                        }

                        return (
                            <div
                                key={index}
                                className="e9header-quick-search-types-item"
                                title={name}
                                onClick={() => this.onQuickSearchTypesClick(item)}
                            >
                                {iconComp}
                                <span>{name}</span>
                            </div>
                        );
                    })
                }
            </div>
        );
    }

    onQuickSearchTypesClick(item) {
        this.props.onVisibleChange(false);

        const {portalThemeStore} = this.props;
        portalThemeStore.onQuickSearchTypesSelectedChange(item);
    }
}

export default E9QuickSearchTypes;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9QuickSearchTypes.js